import Text from 'components/shared/Text'
import { Wrapper } from './styles'
import tippi from 'assets/icons/tippi.svg'
import Box from 'components/shared/Box'
import { FormattedMessage } from 'react-intl'
import Link from 'components/shared/Link'
import { useResolutions } from 'store/resolutions'
import { scrollTo } from 'helpers/animateScroll'
import { useApp } from 'store/steps'

const EmptyOffer = ({ index }: { index: number }) => {
    const { goBackToStep } = useApp()
    const { isCreatorAccommodation } = useApp()
    const { isTablet } = useResolutions()
    const handleClick = () => {
        if (isCreatorAccommodation) {
            scrollTo({
                id: 'planYourStay',
                duration: 500,
                margin: 50,
            })
        } else {
            goBackToStep('tickets')
        }
    }
    const formatedMessageChunks = {
        span: (chunks: string[]) => (
            <>
                {isTablet && <br />}
                <Link
                    variant="primary"
                    onClick={handleClick}
                    data-testid={`accommo-${index}-button-change-visit-date`}
                >
                    {chunks}
                </Link>
            </>
        ),
    }
    return (
        <Wrapper
            padding={32}
            direction={['column', 'row']}
            gap={[16, 32]}
            align="center"
        >
            <Box>
                <img src={tippi} alt="" />
            </Box>
            <Box align={['center', 'flex-start']}>
                <Text variant="heading4" color="secondary_500" mb={[24, 12]}>
                    <FormattedMessage
                        id="accommodation.empty_offer.info"
                        defaultMessage="Bardzo nam przykro! Nie mamy już dostępnych bungalowów w wybranym terminie"
                    />
                </Text>
                <Text variant="body" color="grayscale_900">
                    {isCreatorAccommodation ? (
                        <FormattedMessage
                            id="accommodation.empty_offer.cta_v2"
                            defaultMessage="Spróbuj ponownie później lub <span>sprawdź inne terminy</span>"
                            values={formatedMessageChunks}
                        />
                    ) : (
                        <FormattedMessage
                            id="accommodation.empty_offer.cta"
                            defaultMessage="Spróbuj ponownie później lub <span>zmień datę przyjazdu</span>"
                            values={formatedMessageChunks}
                        />
                    )}
                </Text>
            </Box>
        </Wrapper>
    )
}

export default EmptyOffer
